import { useEffect } from "react";

import { usePaymentPage } from "../PaymentPageContext";
import { usePaymentForm } from "./PaymentFormContext";

export function useHandleAmountQueryString(amount) {
  const { state, dispatch: pageDispatch } = usePaymentPage();
  const { dispatch: formDispatch } = usePaymentForm();
  const isFullyAuthed = state.user?.loginLevel === "full";
  const hasPaymentMethod = state.paymentMethods?.length > 0;
  const { isACHAllowed } = state.network;
  const suggestedAmounts = state.fund.paymentPageSettings.suggestedAmounts?.filter(x => x !== '0' && x);

  useEffect(
    function handleAmountQueryParam() {
      let amountInDollars = 0;
      
      if (amount && Number(amount)) {
        amountInDollars = Number(amount) / 100;

        if (!amount.endsWith("00")) {
          // so we don't end up with something like $100.5 in the input
          amountInDollars = amountInDollars.toFixed(2);
        }
      } else if (suggestedAmounts?.length === 1) {
        amountInDollars = Number(suggestedAmounts[0]);
      }

      if (amountInDollars > 0) {
        pageDispatch({
          type: "setAmount",
          payload: amountInDollars,
        });
        formDispatch({
          type: "setFormStages",
          payload: {
            amount: "complete",
            auth: isFullyAuthed ? "isFullyLoggedIn" : "requestCode",
            paymentInfo: getPaymentInfoValue({
              isFullyAuthed,
              hasPaymentMethod,
              isACHAllowed,
            }),
          },
        });
        formDispatch({
          type: "setHasAmountURLParam",
          payload: true,
        });
      }
    },
    // This should only run once when the page loads.
    // eslint-disable-next-line
    []
  );
}

function getPaymentInfoValue({
  isFullyAuthed,
  hasPaymentMethod,
  isACHAllowed,
}) {
  if (isFullyAuthed && hasPaymentMethod) {
    return "methodSelected";
  } else if (isFullyAuthed && isACHAllowed) {
    return "chooseAddMethodType";
  } else if (isFullyAuthed) {
    return "addCard";
  } else {
    return "untouched";
  }
}
